import '../../../../types/product.js';
import { SINGLE_PURCHASE } from '../../../../types/purchase-types.js';
import { isSubscriptionPurchase } from '../../../../types/typeguards.js';

const isDeliveryIntervalValid = ({ configurations  })=>{
    const { purchaseType , subscriptionPurchaseConfigurations  } = configurations;
    if (isSubscriptionPurchase(purchaseType)) {
        return subscriptionPurchaseConfigurations.deliveryInterval !== null;
    }
    return undefined;
};
const isConfiguratorValid = (state)=>{
    const { purchaseType  } = state.configurations;
    if (isSubscriptionPurchase(purchaseType)) {
        return !!isDeliveryIntervalValid(state);
    }
    // Single purchase is always valid
    return true;
};
const getInitialState = (defaultDeliveryInterval)=>{
    return {
        configurations: {
            purchaseType: SINGLE_PURCHASE,
            subscriptionPurchaseConfigurations: {
                deliveryInterval: defaultDeliveryInterval !== null && defaultDeliveryInterval !== void 0 ? defaultDeliveryInterval : null
            },
            quantity: 1
        },
        configurator: {
            invalidSubmissionsCount: undefined,
            isConfiguratorValid: true,
            deliveryInterval: {
                isValid: defaultDeliveryInterval ? true : undefined,
                showError: false
            }
        }
    };
};

export { getInitialState, isConfiguratorValid, isDeliveryIntervalValid };
//# sourceMappingURL=helpers.js.map
